import * as React from "react";
import { forwardRef } from "react";
const SvgArrowright = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 6.638, height: 10.979, viewBox: "0 0 6.638 10.979", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.148 0-.001 1.174l3.5 3.5.808.817-.808.817-3.5 3.5 1.149 1.174 4.9-4.9.587-.587-.587-.587Z", className: "s3daf7d4c78d2a210fa8e889977a23420__a" }));
const ForwardRef = forwardRef(SvgArrowright);
export { ForwardRef as ReactComponent };
